const config = {
  development: {
    apiBaseUrl: "https://localhost:7092/cark/api/",
    apiBaseUrl2: "https://localhost:7092/api/",
    adminApi: "https://localhost:7092/admin/api/",
    jsonUrl: "https://localhost:7092/carkdata.json",
    cssJsonUrl: "https://localhost:7092/configCSS.json",
    apiBaseUrlAdvanced: "https://localhost:7092/api/advanced/",
    configUrl: "/config.json",
    wheelConfigUrl: "/WheelConfig.json",
  },
  production: {
    apiBaseUrl:
      "https://api." +
      window.location.hostname.split(".").slice(1).join(".") +
      "/cark/api/",
    apiBaseUrl2:
      "https://api." + window.location.hostname.split(".").slice(1).join(".") + "/api/",
    adminApi:
      "https://api." +
      window.location.hostname.split(".").slice(1).join(".") +
      "/admin/api/",
    apiBaseUrlAdvanced:
      "https://api." +
      window.location.hostname.split(".").slice(1).join(".") +
      "/api/advanced/",
    jsonUrl: "/carkdata.json",
    cssJsonUrl: "/configCSS.json",
    configUrl: "/config.json",
    wheelConfigUrl: "/WheelConfig.json",
  },
};

const env = 'production';
export default config[env];
